import React, { Fragment } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import moment from 'moment';
import numeral from 'numeral';

import ThumbUp from '@material-ui/icons/ThumbUp';
import ThumbUpAlt from '@material-ui/icons/ThumbUpAlt';
import DirectionsRun from '@material-ui/icons/DirectionsRun';
import { GoTools } from "react-icons/go";

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Card,
    CardHeader,
    CardContent,
    Typography,
    makeStyles,
    Icon,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    Grid,
    colors
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: '100%',
        maxHeight: '25vh',
    },
    list: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        minWidth: 550,
        maxHeight: '25vh',
    },
    icon: {
        height: 40,
        width: 40
    },
    abs: {
        maxHeight: '35vh',
        minWidth: '50vh',
        overflow: 'auto'
    },
    avatarStatus: {
        height: 60,
        width: 60,
        backgroundColor: colors.blue[500]
    },
    avatar: {
        height: 32,
        width: 32,
        backgroundColor: colors.orange[500]
    }
}));

const Treatment = ({ icon, item, open, closeTreatment, updateTreatmentValues, statusHistory, statusRegister }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Tratamento de Ocorrência
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Box
                        mt={2}
                        display="flex"
                        flexDirection="column"
                        height="100%"
                        justifyContent="center"
                    >
                        <Formik
                            initialValues={statusRegister}
                            validationSchema={
                                Yup.object().shape(
                                    {
                                        statusEmpresa: Yup.string().max(100).required('Escolha da ação é o obrigatória'),
                                        justificativa: Yup.string().max(250).required('Justificativa / Comentário a respeito da ação escolhida é obrigatória')
                                    }
                                )
                            }

                            onSubmit={(values, formik) => {
                                updateTreatmentValues(values, statusHistory);
                                formik.setSubmitting(false);
                            }}
                        >
                            {({
                                errors,
                                handleBlur,
                                handleChange,
                                handleSubmit,
                                isSubmitting,
                                touched,
                                values
                            }) => (

                                <form onSubmit={handleSubmit}>

                                    <Grid container
                                        spacing={2}
                                        className={classes.baroperation}
                                        direction="row"
                                        justify="flex-start"
                                        alignItems="flex-start"
                                    >
                                        <Grid item
                                            sm={6}
                                            xs={12}>

                                            <Card>
                                                <CardHeader variant="h6"
                                                    avatar={
                                                        <Avatar className={classes.avatar}>
                                                            <Icon component={icon}></Icon>
                                                        </Avatar>
                                                    }
                                                    title={
                                                        <Fragment>
                                                            <Typography
                                                                component="span"
                                                                variant="h5"
                                                                color="textPrimary">
                                                                <b>Número da Ocorrência: </b>
                                                            </Typography>
                                                            <Typography
                                                                component="span"
                                                                variant="h5"
                                                                color="secondary">
                                                                {item.numero}
                                                            </Typography>
                                                        </Fragment>
                                                    }

                                                />

                                                <Divider></Divider>

                                                <CardContent>
                                                    <Box
                                                        alignItems="center"
                                                        display="flex"
                                                        flexDirection="column">

                                                        <Box
                                                            display="flex"
                                                            justifyContent="center"
                                                            mb={1}
                                                        >
                                                            <Avatar
                                                                className={classes.avatarStatus}
                                                            >
                                                                {<Icon component={icon}></Icon>}
                                                            </Avatar>
                                                        </Box>

                                                        <Typography
                                                            style={{ color: item.color }}
                                                            variant="h4">
                                                            ( Status Atual é <b>{item.statusEmpresa.nome}</b> )
                                                        </Typography>

                                                        <Typography
                                                            className={classes.dateText}
                                                            color="secondary"
                                                            variant="h5">
                                                            <b>Abertura:</b> {moment(item.abertura).format('DD/MM/YYYY')}
                                                        </Typography>

                                                        <Typography
                                                            color="primary"
                                                            variant="h5">
                                                            <b>Centro de Custo:</b> {item.unidade.codigo}
                                                        </Typography>

                                                        <Typography
                                                            color="body1"
                                                            variant="h6">
                                                            <b>Nome:</b>{item.unidade.nome}
                                                        </Typography>

                                                        <Typography
                                                            color="body1"
                                                            variant="h6">
                                                            <b>Tipo: </b>{(item.unidade.tipo) ? (item.unidade.tipo.nome) : ('Não Informado')}
                                                        </Typography>
                                                        <Typography
                                                            color="body1"
                                                            variant="h6">
                                                            <b>Município: </b>{(item.unidade.municipio) ? (item.unidade.municipio.nome) : ('Não Informado')}
                                                        </Typography>
                                                        <Typography
                                                            color="textSecondary"
                                                            variant="h6">
                                                            {item.unidade.endereco} - {item.unidade.bairro} - {item.unidade.cep}
                                                        </Typography>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                            <Box mt={2} ></Box>
                                            <Card>

                                                <CardHeader variant="h6"
                                                    avatar={
                                                        <Avatar className={classes.avatar}>
                                                            <GoTools /></Avatar>
                                                    }
                                                    title={
                                                        <Typography
                                                            component="span"
                                                            variant="h5"
                                                            color="textPrimary">
                                                            <b>Serviço</b>
                                                        </Typography>
                                                    }
                                                />

                                                <Divider></Divider>
                                                <CardContent square="true" className={classes.abs}>

                                                    <List dense className={classes.list}>

                                                        <ListItem button>
                                                            <ListItemAvatar>
                                                                <Icon component={GoTools} style={{ color: colors.blue[500] }}  ></Icon>
                                                            </ListItemAvatar>
                                                            <ListItemText
                                                                primary={
                                                                    <Fragment>
                                                                        <Typography
                                                                            component="span"
                                                                            variant="body2"
                                                                            color="textPrimary">
                                                                            <b>Categoria:</b> {item.categoria.nome}
                                                                        </Typography>
                                                                    </Fragment>}
                                                                secondary={
                                                                    <Fragment>
                                                                        <Typography
                                                                            component="span"
                                                                            variant="body2"
                                                                            color="textPrimary">
                                                                            <b>Descrição:</b> {(item.descricao) ? (item.descricao) : ('( Sem Descrição )')}
                                                                        </Typography>
                                                                        <br></br>
                                                                        <Typography
                                                                            component="span"
                                                                            variant="body2"
                                                                            color="textPrimary">
                                                                            <b>Sintoma:</b> {(item.sintoma) ? (item.sintoma.nome) : ('( Sem Informação de Sintoma )')}
                                                                        </Typography>
                                                                        <br></br>
                                                                        <Typography
                                                                            component="span"
                                                                            variant="body2"
                                                                            color="textPrimary">
                                                                            <b>Local do Sintoma:</b> {(item.localSintoma) ? (item.localSintoma.nome) : ('( Sem Informação de Localização do Sintoma )')}
                                                                        </Typography>
                                                                        <br></br>
                                                                        <Typography
                                                                            component="span"
                                                                            variant="body2"
                                                                            color="textPrimary">
                                                                            <b>Departamento:</b> {(statusHistory.tecnico) ? (statusHistory.tecnico.prestadora.nome) : ('( Não Informada )')}
                                                                        </Typography>
                                                                        <br></br>
                                                                        <Typography
                                                                            component="span"
                                                                            variant="body2"
                                                                            color="textPrimary">
                                                                            <b>Técnico:</b> {(statusHistory.tecnico) ? (statusHistory.tecnico.nome) : ('( Não Informado )')}
                                                                        </Typography>
                                                                        <br></br>
                                                                        <Typography
                                                                            component="span"
                                                                            variant="body2"
                                                                            color="textPrimary">
                                                                            <b>Serviço Executado:</b> {(item.servicoExecutado) ? (item.servicoExecutado) : ('( Sem Informação de Execução )')}
                                                                        </Typography>

                                                                    </Fragment>
                                                                }>
                                                            </ListItemText>
                                                        </ListItem>
                                                    </List>

                                                </CardContent>
                                            </Card>

                                        </Grid>

                                        <Grid item
                                            sm={6}
                                            xs={12}>

                                            <Card>
                                                <CardHeader variant="h6"
                                                    avatar={
                                                        <Avatar className={classes.avatar}>
                                                            <ThumbUpAlt /></Avatar>
                                                    }
                                                    title={
                                                        <Typography
                                                            component="span"
                                                            variant="h5"
                                                            color="textPrimary">
                                                            <b>Registro de Alteração de Status</b>
                                                        </Typography>
                                                    }
                                                />

                                                <Divider></Divider>

                                                <CardContent square="true" className={classes.abs} >

                                                    {(statusHistory.registros.length > 0) ? (

                                                        <List dense className={classes.list} >

                                                            {statusHistory.registros.map((treatment, index) => {
                                                                return (
                                                                    <ListItem key={index} button>
                                                                        <ListItemAvatar>
                                                                            <Icon component={ThumbUp} style={{ color: colors.blue[400] }}  ></Icon>
                                                                        </ListItemAvatar>
                                                                        <ListItemText id={index}
                                                                            primary={
                                                                                <Fragment>
                                                                                    <Typography
                                                                                        component="span"
                                                                                        variant="h6"
                                                                                        color="textPrimary">
                                                                                        <b>Data:</b> {moment(treatment.data).format('DD/MM/YYYY HH:mm:ss')}
                                                                                    </Typography>
                                                                                </Fragment>}
                                                                            secondary={
                                                                                <Fragment>
                                                                                    <Typography
                                                                                        component="span"
                                                                                        variant="body2"
                                                                                        color="textPrimary">
                                                                                        <b>Status Registrado:</b> {(treatment.statusEmpresa) ? treatment.statusEmpresa.nome : 'Não Informado'}
                                                                                    </Typography>
                                                                                    <br></br>
                                                                                    <Typography
                                                                                        component="span"
                                                                                        variant="body2"
                                                                                        color="textPrimary">
                                                                                        <b>Justificativa:</b> {treatment.justificativa}
                                                                                    </Typography>
                                                                                    <br></br>
                                                                                    <Typography
                                                                                        component="span"
                                                                                        variant="body2"
                                                                                        color="textPrimary">
                                                                                        <b>Usuário:</b> {(treatment.usuario) ? (treatment.usuario) : ('Não Informado')}
                                                                                    </Typography>
                                                                                </Fragment>
                                                                            }>
                                                                        </ListItemText>
                                                                    </ListItem>
                                                                );
                                                            })}
                                                        </List>

                                                    ) : (
                                                        <Box className={classes.root}>
                                                            <Typography
                                                                component="span"
                                                                variant="body2"
                                                                color="textPrimary">
                                                                Nenhuma Mudança de Status Registrada
                                                            </Typography>
                                                        </Box>

                                                    )}

                                                </CardContent>
                                            </Card>

                                            <Box mt={2} ></Box>

                                            <Card>
                                                <CardHeader variant="h6"
                                                    avatar={
                                                        <Avatar className={classes.avatar}>
                                                            <DirectionsRun /></Avatar>
                                                    }

                                                    title={<Typography
                                                        component="span"
                                                        variant="h5"
                                                        color="textPrimary">
                                                        <b>Executar Ação</b>
                                                    </Typography>}

                                                />

                                                <Divider></Divider>

                                                <CardContent square="true">

                                                    <Grid container
                                                        direction="row"
                                                        justify="flex-start"
                                                        alignItems="flex-start"
                                                        spacing={1}
                                                    >
                                                        <Grid
                                                            item
                                                            xs={12}
                                                        >
                                                            <FormControl variant="outlined" fullWidth>
                                                                <InputLabel shrink htmlFor="statusEmpresa" required >Mudar para Novo Status</InputLabel>
                                                                <Select notched
                                                                    autosize={true}
                                                                    required
                                                                    error={Boolean(touched.statusEmpresa && errors.statusEmpresa)}
                                                                    fullWidth={true}
                                                                    helperText={touched.statusEmpresa && errors.statusEmpresa}
                                                                    value={values.statusEmpresa}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    label="Mudar para Novo Status"
                                                                    variant="outlined"
                                                                    inputProps={{
                                                                        name: 'statusEmpresa',
                                                                        id: 'statusEmpresa',
                                                                    }}
                                                                >
                                                                    <MenuItem value={null}>
                                                                        <em>Selecione uma das opções abaixo</em>
                                                                    </MenuItem>
                                                                    {statusHistory.acoes.map((action) => (
                                                                        <MenuItem key={action.id} value={action.id}>{action.nome}</MenuItem>
                                                                    ))}

                                                                </Select>
                                                            </FormControl>
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            xs={12}
                                                        >
                                                        </Grid>


                                                        <Grid
                                                            item
                                                            xs={12}
                                                        >
                                                            <TextField
                                                                error={Boolean(touched.justificativa && errors.justificativa)}
                                                                fullWidth
                                                                helperText="Coloque aqui comentário ou justificativa a respeito da ação escolhida (250 caracteres)."
                                                                label="Justificativa / Comentário a respeito da ação escolhida"
                                                                rows={2}
                                                                size={10}
                                                                length={250}
                                                                multiline
                                                                margin="normal"
                                                                name="justificativa"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.justificativa}
                                                                variant="outlined"
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        </Grid>

                                                    </Grid>

                                                </CardContent>
                                            </Card>

                                        </Grid>

                                    </Grid>

                                    <Box my={1}></Box>

                                    <Divider />

                                    <Box my={1}>
                                        <Grid container
                                            direction="row"
                                            justify="flex-end"
                                            alignItems="baseline"
                                            spacing={1}  >
                                            <Grid item>

                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    type="submit"
                                                    variant="contained"
                                                >
                                                    Executar
                                                </Button>

                                            </Grid>

                                            <Grid item >

                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    variant="contained"
                                                    onClick={() => { closeTreatment() }}>
                                                    Fechar
                                                </Button>

                                            </Grid>
                                        </Grid>
                                    </Box>
                                </form>
                            )}
                        </Formik>
                    </Box>

                </DialogContent>

            </Dialog >

        </Fragment >
    );
};

export default Treatment;